import { gql } from '@apollo/client';

export const SAVE_SPLIT_ROUTE_CACHE = gql`
    mutation SaveSplitRouteCache($warehouseId: Long!, $areaId: Long!, $data: String!) {
        saveSplitRouteCache(warehouseId: $warehouseId, areaId: $areaId, data: $data)
    }
`;

export const GET_SPLIT_ROUTE_CACHE = gql`
    query GetSplitRouteCache($warehouseId: Long!, $areaId: Long!) {
        getSplitRouteCache(warehouseId: $warehouseId, areaId: $areaId)
    }
`;

export const DELETE_SPLIT_ROUTE_CACHE = gql`
    mutation DeleteSplitRouteCache($warehouseId: Long!, $areaId: Long!) {
        deleteSplitRouteCache(warehouseId: $warehouseId, areaId: $areaId)
    }
`;

export const BATCH_GET_SPLIT_ROUTE_CACHE = gql`
    query BatchGetSplitRouteCache($warehouseId: Long!, $areaIds: [Long!]!) {
        batchGetSplitRouteCache(warehouseId: $warehouseId, areaIds: $areaIds) {
            areaId
            data
        }
    }
`;

export interface SplitRouteCacheItem {
    areaId: number;
    data: string | null;
}

export interface SaveSplitRouteCacheResponse {
    saveSplitRouteCache: boolean;
}

export interface GetSplitRouteCacheResponse {
    getSplitRouteCache: string | null;
}

export interface DeleteSplitRouteCacheResponse {
    deleteSplitRouteCache: boolean;
}

export interface BatchGetSplitRouteCacheResponse {
    batchGetSplitRouteCache: SplitRouteCacheItem[];
}

